import { FilterBase } from "../../../models";


export class CompanyFilter extends FilterBase {

  GetFilter(inputValue: string) {
    return {
      filter: {
        logic: "or",
        filters: [
          {
            field: "name",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "description",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    };
  }

}
